import { render } from "./LockDesignerLanding.vue?vue&type=template&id=bab6ade6&ts=true"
import script from "./LockDesignerLanding.vue?vue&type=script&lang=ts"
export * from "./LockDesignerLanding.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\src\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__